import { render, staticRenderFns } from "./ExpensesNavigation.vue?vue&type=template&id=fca03354&scoped=true"
import script from "./ExpensesNavigation.vue?vue&type=script&lang=js"
export * from "./ExpensesNavigation.vue?vue&type=script&lang=js"
import style0 from "./ExpensesNavigation.vue?vue&type=style&index=0&id=fca03354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca03354",
  null
  
)

export default component.exports